import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import img from "../assets/media/mby-high-resolution-logo-transparent .png";
import { Stack } from "@mui/material";
import logo from "../assets/media/logo2.png";
import { useNavigate } from "react-router-dom";
import useAuthCalls from "../service/useAuthCalls";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

const pages = ["Newblog", "About"];

function Navbar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const { logOut } = useAuthCalls();
  const { user } = useSelector((state) => state.auth);
   const today = new Date();
   const options = {
    //  weekday: "long",
     year: "numeric",
     month: "long",
     day: "numeric",
   };
   const formattedDate = today.toLocaleDateString("us-US", options);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const navigate = useNavigate();

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "#293040", color: "#C9AD8B", padding: "20px" }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box
            onClick={() => navigate("/")}
            alt="logo img"
            sx={{
              display: { xs: "none", md: "flex" },
              marginRight: "1rem",
              cursor: "pointer",
            }}
          >
            <img src={img} alt="logo img" style={{ width: "150px" }} />
          </Box>
          {/* <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: "none", md: "flex" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            LOGO
          </Typography> */}

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography
                    style={{ color: "#C9AD8B" }}
                    onClick={() => {
                      handleCloseNavMenu();
                      navigate(`/${page}`);
                    }}
                    textAlign="center"
                  >
                    {page}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box alt="logo img" sx={{ display: { xs: "flex", md: "none" } }}>
            <img
              onClick={() => navigate("/")}
              src={img}
              alt="logo img"
              style={{ width: "150px", cursor: "pointer" }}
            />
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              flexGrow: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
            }}
          ></Typography>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => {
                  handleCloseNavMenu();
                  navigate(`/${page}`);
                }}
                sx={{
                  my: 2,
                  mr: 1,
                  color: "#eaa79c",
                  fontWeight: 600,
                  display: "block",
                  "&:hover": { backgroundColor: "beige" },
                  transition: "all 1s ease",
                }}
              >
                {page}
              </Button>
            ))}
          </Box>
          <Typography
            sx={{ display: { xs: "none", md: "flex" } }}
            style={{ textAlign: "center", position: "absolute", left: "50%" }}
          >
            {formattedDate}
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexGrow: 0,
              flexDirection: "row",
              gap: "1rem",
            }}
          >
            {user ? <Typography>{user}</Typography> : undefined}
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar
                  alt="Remy Sharp"
                  src={logo}
                  sx={{ width: 40, height: 40 }}
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {" "}
              {user ? (
                <>
                  {/* <MenuItem onClick={handleCloseUserMenu}>
                    <Typography
                      onClick={() => navigate("Login")}
                      textAlign="center"
                    >
                      Sign In
                    </Typography>
                  </MenuItem> */}
                  <MenuItem onClick={handleCloseUserMenu}>
                    <Typography
                      onClick={() => navigate("myBlogs")}
                      textAlign="center"
                    >
                      MyBlogs
                    </Typography>
                  </MenuItem>
                  <MenuItem onClick={handleCloseUserMenu}>
                    <Typography onClick={() => 
                    {
                      logOut()
                      Swal.fire({
                        title: "Goodbye",
                        text: "We will miss you 🙋‍♂️",
                        imageUrl:
                          "https://img.freepik.com/free-vector/goodbye-sunburst-lettering-background_23-2147958525.jpg?w=740&t=st=1708884775~exp=1708885375~hmac=75590236ace0f3be8b97f802c5bcbcd4d8ac8bdcacf1c7da62cca7a353eb7e14",
                        imageWidth: 400,
                        imageHeight: 400,
                        imageAlt: "Custom image",
                      });
                      }} textAlign="center">
                      Log Out
                    </Typography>
                  </MenuItem>
                </>
              ) : (
                <>
                  <MenuItem onClick={handleCloseUserMenu}>
                    <Typography
                      onClick={() => navigate("Login")}
                      textAlign="center"
                    >
                      Sign In
                    </Typography>
                  </MenuItem>
                  <MenuItem onClick={handleCloseUserMenu}>
                    <Typography
                      onClick={() => navigate("myBlogs")}
                      textAlign="center"
                    >
                      MyBlogs
                    </Typography>
                  </MenuItem>
                </>
              )}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Navbar;
